import styled from 'foundations-theming/utils';
// Ref: https://git.hubteam.com/HubSpot/universal-associations-select/blob/d8c8e2d97d99db9fa766d15ae4c20378f5ddd3ec/universal-associations-select/static/js/helpers/SkeletonText.ts#L20

import PropTypes from 'prop-types';

/**
 * A simple skeleton ui for text which is currently loading; shows a gray bar.
 * It's approximately the height of average text in the current font size (0.8em),
 * so it looks sort of like text when you squint.
 *
 * Example:
 *   <SkeletonText />
 *   <SkeletonText width={80} />
 *
 * See https://git.hubteam.com/HubSpot/conversations-skeleton-state
 */

const getSize = value => typeof value === 'number' ? `${value}px` : value;
const SkeletonText = styled.div.withConfig({
  displayName: "SkeletonText",
  componentId: "cmbnop-0"
})(["background-color:", ";border-radius:999px;display:inline-block;height:0.8em;width:", ";"], ({
  theme
}) => theme.color['fill-field-default'], ({
  width
}) => getSize(width));

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
SkeletonText.defaultProps = {
  width: '6em'
};
SkeletonText.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default SkeletonText;